export const getColor = (key) => {
  const colors = [
    '#007d00',
    '#001d9e',
    // '#007100',
    // '#9793dd',
    // '#1890ff',
    // '#ff3000',
    // '#fadb14',
  ];
  return colors[key % colors.length];
};

export const getBarSize = 20;

export const getDates = (startDate,endDate) => {
  let dates = [];
  let currentDate = startDate.clone();
  let lastDate = endDate.clone();

  while (currentDate <= lastDate) {
      dates.push(currentDate.format('YYYY-MM-DD'));
      currentDate.add(1, 'days');
  }
  return dates;
};

export const getUserInfo = (data,field = '') => {
  if(!data) return;
  
  const dataInfo = JSON.parse(atob(data.split('.')[1]));
  return field ? dataInfo[field] : dataInfo;
}

export const START_DATE = 9;
export const END_DATE = 2;

export const networkIcons = {
  'Unity': 'unity-sm.png',
  'Google': 'google-sm.png',
  'Facebook Ads': 'facebook-sm.png',
  'Mintegral': 'mintegral-sm.png',
  'Applovin': 'applovin-sm.png',
  'IronSource': 'iron_source-sm.png',
  'Liftoff': 'liftoff-sm.png',
  'Tiktok': 'tiktok-sm.png',
  'Yandex': 'yandex-sm.png'
};